// src/components/customers/customersApi.js
import { apiFetch, apiFetchBlob } from '../../api.js';

export async function apiExportCustomers() {
  return apiFetchBlob('/api/customers/export');
}

export async function apiGetCustomerOrders(uid) {
  return apiFetch(`/api/customers/${uid}/orders`);
}

export async function apiGetCustomerTags(uid) {
  return apiFetch(`/api/customers/${uid}/tags`);
}

export async function apiGetCustomerLoyalty(uid) {
  return apiFetch(`/api/customers/${uid}/loyalty`);
}

export async function apiGetCustomersAnalytics() {
  return apiFetch('/api/customers/analytics/overview');
}

/* -----------------------------
   Inactifs / Relances
----------------------------- */

// Clients inactifs depuis X mois (150 jours ≈ 5 mois)
export async function apiGetInactiveCustomers({ months = 5, limit = 100 } = {}) {
  const params = new URLSearchParams();
  params.set('months', String(months));
  params.set('limit', String(limit));
  return apiFetch(`/api/customers/alerts/inactive?${params.toString()}`);
}

// Clients devenus inactifs récemment (ex: dernières 24h)
export async function apiGetNewInactiveCustomers({ hours = 24, limit = 200 } = {}) {
  const params = new URLSearchParams();
  params.set('hours', String(hours));
  params.set('limit', String(limit));
  return apiFetch(`/api/customers/alerts/new-inactive?${params.toString()}`);
}

// Option: liste paginée en utilisant filter=inactive (is_active=false)
export async function apiGetCustomers({ search = '', filter = 'all', page = 1, limit = 50 } = {}) {
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  if (filter) params.set('filter', filter);
  params.set('page', String(page));
  params.set('limit', String(limit));
  return apiFetch(`/api/customers?${params.toString()}`);
}
